module.exports = require("@visa/vds-web/dist/_json/theme.js");